<template>
  <div id="login">
    <transition name="fade">
      <div v-if="performingRequest" class="loading">
        <p>Loading...</p>
      </div>
    </transition>
    <section>
      <div class="col1">
        <h1>Client Data Enrichment</h1>
        <p>
          Welcome to the
          <a href="https://www.brilliantmetrics.com/" target="_blank"
            >Brilliant Metrics</a
          >
          client data enrichment app
        </p>
      </div>
      <div
        class="col2"
        :class="{ 'signup-form': !showLoginForm && !showPasswordReset }"
      >
        <form v-if="showLoginForm" @submit.prevent>
          <h1>Welcome Back</h1>

          <label for="email1">Email</label>
          <input
            v-model.trim="loginForm.email"
            type="text"
            placeholder="you@email.com"
            id="email1"
          />

          <label for="password1">Password</label>
          <input
            v-model.trim="loginForm.password"
            type="password"
            placeholder="******"
            id="password1"
          />

          <button @click="login" class="button">Log In</button>

          <div class="extras">
            <a @click="togglePasswordReset">Forgot Password</a>
            <a @click="toggleSignupForm">Create an Account</a>
          </div>
        </form>
        <form v-if="showSignupForm" @submit.prevent>
          <h1>Get Started</h1>

          <label for="name">Name</label>
          <input
            v-model.trim="signupForm.name"
            type="text"
            placeholder="Savvy Apps"
            id="name"
          />

          <label for="title">Title</label>
          <input
            v-model.trim="signupForm.title"
            type="text"
            placeholder="Company"
            id="title"
          />

          <label for="email2">Email</label>
          <input
            v-model.trim="signupForm.email"
            type="text"
            placeholder="you@email.com"
            id="email2"
          />

          <label for="password2">Password</label>
          <input
            v-model.trim="signupForm.password"
            type="password"
            placeholder="min 6 characters"
            id="password2"
          />

          <button @click="signup" class="button">Sign Up</button>

          <div class="extras">
            <a @click="toggleSignupForm">Back to Log In</a>
          </div>
        </form>
        <form v-if="showPasswordReset" @submit.prevent class="password-reset">
          <div v-if="!passwordResetSuccess">
            <h1>Reset Password</h1>
            <p>
              Forgot your password, eh? Fill out the form below and we'll hook
              you up via email.
            </p>
            <label for="email3">Email</label>
            <input
              v-model.trim="passwordForm.email"
              type="text"
              placeholder="you@email.com"
              id="email3"
            />
            <button @click="resetPassword" class="button">Submit</button>
            <div class="extras">
              <a @click="togglePasswordReset">Back to Log In</a>
            </div>
          </div>
          <div v-else>
            <h1>Help is On The Way!</h1>
            <p>
              Check your email for a link to reset your password and get back to
              work.
            </p>
            <button @click="togglePasswordReset" class="button">
              Back to Login
            </button>
          </div>
        </form>
        <transition name="fade">
          <div v-if="errorMsg !== ''" class="error-msg">
            <p>{{ errorMsg }}</p>
          </div>
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      signupForm: {
        name: "",
        title: "",
        email: "",
        password: ""
      },
      passwordForm: {
        email: ""
      },
      showLoginForm: true,
      showPasswordReset: false,
      passwordResetSuccess: false,
      performingRequest: false,
      errorMsg: ""
    };
  },
  methods: {
    toggleSignupForm() {
      this.showLoginForm = !this.showLoginForm;
      this.showSignupForm = !this.showSignupForm;
    },
    togglePasswordReset() {
      this.showLoginForm = !this.showLoginForm;
      this.showPasswordReset = !this.showPasswordReset;
    },
    login() {
      this.performingRequest = true;
      fb.auth
        .signInWithEmailAndPassword(
          this.loginForm.email,
          this.loginForm.password
        )
        .then(user => {
          this.$store.commit("setCurrentUser", user.user);
          this.$store.dispatch("fetchUserProfile");
          this.$router.push("/profile");
        })
        .catch(err => {
          console.log(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },

    signup() {
      this.performingRequest = true;
      fb.auth
        .createUserWithEmailAndPassword(
          this.signupForm.email,
          this.signupForm.password
        )
        .then(userCred => {
          const user = userCred.user;
          this.$store.commit("setCurrentUser", user);
          console.log(user);

          // create user obj
          fb.usersCollection
            .doc(user.uid)
            .set({
              name: this.signupForm.name,
              title: this.signupForm.title
            })
            .then(() => {
              this.$store.dispatch("fetchUserProfile");
              this.$router.push("/profile");
            })
            .catch(err => {
              console.log(err);
              this.performingRequest = false;
            });
        })
        .catch(err => {
          console.log(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },
    resetPassword() {
      this.performingRequest = true;

      fb.auth
        .sendPasswordResetEmail(this.passwordForm.email)
        .then(() => {
          this.performingRequest = false;
          this.passwordResetSuccess = true;
          this.passwordForm.email = "";
        })
        .catch(err => {
          console.log(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    }
  }
};
</script>
